// extracted by mini-css-extract-plugin
export default {"search":"Schema_search__Y+px5","code":"Schema_code__jNqm6","comment":"Schema_comment__v4paD","btns":"Schema_btns__WlmzY"};